export default "__VITE_ASSET__BXFEbT7M__"